import React from 'react'
import { Box } from '@/components/lib'

function EntryView ({ left, right }) {
  return (
    <Box display={{ md: 'flex' }}>
      <Box>
        <Box m={3} bg='bg.surface' minW='200px' maxW='500px' p={4} rounded='md' position={{ md: 'sticky' }} top='20px'>
          {left}
        </Box>
      </Box>
      <Box width={{ md: '50%', lg: '40%' }} p={4}>
        {right}
      </Box>
    </Box>
  )
}

export default EntryView
